import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http'
import { Injectable } from '@angular/core'
import { from, Observable } from 'rxjs'
import { switchMap } from 'rxjs/operators'
import { AuthTokenService } from '../auth-token.service'

@Injectable()
export class AuthTokenInterceptor implements HttpInterceptor {
  constructor(private readonly authTokenService: AuthTokenService) {}

  intercept(
    httpRequest: HttpRequest<unknown>,
    next: HttpHandler,
  ): Observable<HttpEvent<unknown>> {
    return from(this.authTokenService.getToken()).pipe(
      switchMap(token => {
        return next.handle(
          httpRequest.clone({
            setHeaders: { Authorization: `Bearer ${token}` },
          }),
        )
      }),
    )
  }
}
